// extracted by mini-css-extract-plugin
export default {"todo":"Todo_todo__Wrf0S","btn":"Todo_btn__CLfnv"};